import { memo } from 'react';
import { Row, Col, Menu } from 'antd';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const OrganizationPhysicalPropertiesTab = memo(() => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { key: 'components', label: 'Components' },
    { key: 'property-sets', label: 'Physical Property Sets' },
  ];

  const activeKey = location.pathname.split('/').pop();

  return (
    <Row gutter={16}>
      <Col span={4}>
        <Menu
          selectedKeys={activeKey ? [activeKey] : []}
          onClick={({ key }) => navigate(key)}
          items={menuItems}
        />
      </Col>
      <Col span={20}>
        <Outlet />
      </Col>
    </Row>
  );
});

export default OrganizationPhysicalPropertiesTab;
